import { Protected } from '#components/patterns/routing/Protected.tsx';
import { useAuth } from '#global/context/auth/useAuth.tsx';

type Props = Omit<React.ComponentPropsWithoutRef<typeof Protected>, 'isPermitted'>;

export function IsMFAUser({ children, ...props }: Props) {
  const { user } = useAuth();

  return (
    <Protected isPermitted={() => user?.type === 'user'} {...props}>
      {children}
    </Protected>
  );
}
